import logo2 from '../../images/logo-header.png';

type props = {
    onClick? : () => void
}

const logoStyle = {height: '40px', alignSelf: 'center', cursor: 'pointer'}

export const HeaderMutualLogo : React.FC<props> = (props) => {
    return <img src={logo2} alt="Header Mutual Logo" style={logoStyle}/>
}
